export default "__VITE_ASSET__cff9d52d__"